import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

export const useSkillAssessmentStatusHistory = (skillAssessmentId, enabled = true) =>
  useQuery({
    queryKey: ["skill-assessment-status-history", skillAssessmentId],
    queryFn: () =>
      axios
        .get(`${API_URL}/skill-assessment/${skillAssessmentId}/status-history`)
        .then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && !!skillAssessmentId,
    refetchOnWindowFocus: false,
  });

export const addSkillAssessmentStatusEntry = (skillAssessmentId, payload) =>
  axios.post(`${API_URL}/skill-assessment/${skillAssessmentId}/status-history`, payload);
